import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html {
    font-size: 16px;
    box-sizing: border-box;
    height: 100%;
  }
  body {
    padding: 0;
    margin: 0;
    font-family: ${({ theme: { fontFamily } }) => fontFamily.silka};
    height: 100%;
    > #root {
      height: 100%;
    }

    &.not-overflow,
    &.prevent-overflow {
      overflow: hidden;
      margin-top: 0px;
    }
  }

  * {
    font-family: ${({ theme: { fontFamily } }) => `${fontFamily.silka} !important`}; 
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  a {
    color: inherit;
    text-decoration: none;
    color: inherit;
  }

  button {
    -webkit-tap-highlight-color: transparent;
    background-color: transparent;
    padding: 0;
    font-family: ${({ theme: { fontFamily } }) => fontFamily.silka};
  }

  button,
  input,
  select {
    border: 0;
    outline: none;
  }
  textarea:focus,
  input:focus {
    outline: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0;
  }

  @keyframes slide-in {
    100% {
      transform: translateX(0%);
    }
  }

  @-webkit-keyframes slide-in {
    100% {
      -webkit-transform: translateX(0%);
    }
  }

  @keyframes slide-out {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(100%);
    }
  }

  @-webkit-keyframes slide-out {
    0% {
      -webkit-transform: translateX(0%);
    }
    100% {
      -webkit-transform: translateX(100%);
    }
  }
`;
